import { render, staticRenderFns } from "./mChatEdit.vue?vue&type=template&id=471842ee&scoped=true"
import script from "./mChatEdit.vue?vue&type=script&lang=js"
export * from "./mChatEdit.vue?vue&type=script&lang=js"
import style0 from "./mChatEdit.vue?vue&type=style&index=0&id=471842ee&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471842ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('471842ee')) {
      api.createRecord('471842ee', component.options)
    } else {
      api.reload('471842ee', component.options)
    }
    module.hot.accept("./mChatEdit.vue?vue&type=template&id=471842ee&scoped=true", function () {
      api.rerender('471842ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/autism/mChat/mChat/mChatEdit.vue"
export default component.exports